module.exports = __webpack_public_path__ + "h5/img/master_13.1fe8d076.jpg";